import { validator } from "@/utils/validator";

export const masterDataSkillTestSchema = validator.object().shape({
  skillTestName: validator.string().emptyToNull().label("試験名（技能）").required(),
  cfSkillTestRenewVisaCsvCode: validator.string().emptyToNull().label("期間更新CSVのコード（列CF）").required(),
});
